import {DEFAULT_FONT_SIZE} from '@EmailMakerReact/email-maker-react.constants';
import {SLIDER_CSS_PROPS} from './slider-control.types';
import type {SliderControlDescriptor} from './slider-control.types';

export const widthDescriptor: SliderControlDescriptor = {
  property: 'width',
  labelKey: 'pmwjs_width',
  unit: '%',
  min: 1,
  max: 100,
  step: 1,
  defaults: '100%',
  isResponsive: false,
};

/** Responsive variant of widthDescriptor — design/media/button sectors. */
export const responsiveWidthDescriptor: SliderControlDescriptor = {
  ...widthDescriptor,
  isResponsive: true,
};

export const limitedWidthDescriptor: SliderControlDescriptor = {
  property: 'width',
  labelKey: 'pmwjs_width',
  unit: '%',
  min: 80,
  max: 100,
  step: 1,
  defaults: '80%',
  isResponsive: false,
};

export const paddingDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PADDING,
  labelKey: 'pmwjs_spacing',
  unit: 'px',
  min: 0,
  max: 50,
  step: 1,
  defaults: 0,
  extendedControls: true,
  extendedControlIcons: {
    first: 'icon-edge-spacing-top',
    second: 'icon-edge-spacing-bottom',
    third: 'icon-edge-spacing-left',
    fourth: 'icon-edge-spacing-right',
  },
};

export const borderRadiusDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.BORDER_RADIUS,
  labelKey: 'pmwjs_roundness',
  unit: 'px',
  min: 0,
  max: 100,
  step: 1,
  defaults: 0,
  extendedControls: true,
  extendedControlIcons: {
    first: 'icon-corner-top-right',
    second: 'icon-corner-bottom-right',
    third: 'icon-corner-bottom-left',
    fourth: 'icon-corner-top-left',
  },
};

export const borderWidthDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.BORDER_WIDTH,
  labelKey: 'pmwjs_thickness',
  unit: 'px',
  min: 0,
  max: 20,
  step: 1,
  defaults: 0,
};

export const opacityDescriptor: SliderControlDescriptor = {
  property: 'opacity',
  labelKey: 'pmwjs_opacity',
  unit: '%',
  min: 5,
  max: 100,
  step: 1,
  defaults: 100,
};

export const cellBorderWidthDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_CELL_BORDER_WIDTH,
  labelKey: 'pmwjs_border',
  unit: 'px',
  min: 0,
  max: 20,
  step: 1,
  toggleProp: 'pmw-cell-border-color',
};

export const cellBorderRadiusDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_CELL_BORDER_RADIUS,
  labelKey: 'pmwjs_cell_roundness',
  unit: 'px',
  min: 0,
  max: 100,
  step: 1,
};

export const cellSpacingDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_CELL_SPACING,
  labelKey: 'pmwjs_cell_spacing',
  unit: 'px',
  min: 0,
  max: 20,
  step: 1,
};

/** Reuses pmw-cell-spacing as cellSpacingDescriptor but with a gap label and no unit. */
export const columnSpacingDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_CELL_SPACING,
  labelKey: 'pmwjs_gap',
  unit: '',
  min: 0,
  max: 20,
  step: 1,
};

export const fontSizeDescriptor: SliderControlDescriptor = {
  property: 'font-size',
  labelKey: 'pmwjs_font_size',
  unit: 'px',
  min: 4,
  max: 60,
  step: 1,
  defaults: DEFAULT_FONT_SIZE,
};

export const lineHeightDescriptor: SliderControlDescriptor = {
  property: 'line-height',
  labelKey: 'pmwjs_line_height',
  unit: 'px',
  min: 0,
  max: 60,
  step: 1,
  defaults: '16px',
};

export const heightDescriptor: SliderControlDescriptor = {
  property: 'height',
  labelKey: 'pmwjs_height',
  unit: 'px',
  min: 0,
  max: 80,
  step: 1,
  defaults: '80px',
};

export const letterSpacingDescriptor: SliderControlDescriptor = {
  property: 'letter-spacing',
  labelKey: 'pmwjs_letter_spacing',
  unit: 'px',
  min: 0,
  max: 30,
  step: 1,
  defaults: '0px',
};

export const verticalMarginDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.MARGIN,
  labelKey: 'pmwjs_spacing',
  unit: 'px',
  min: 0,
  max: 50,
  step: 1,
  defaults: '0px',
  extendedControls: true,
  extendedControlIcons: {
    first: 'icon-edge-spacing-top',
    second: 'icon-edge-spacing-bottom',
    third: 'icon-edge-spacing-left',
    fourth: 'icon-edge-spacing-right',
  },
};

export const socialIconGapDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_ICON_MARGIN,
  labelKey: 'pmwjs_icon_spacing',
  unit: 'px',
  min: 0,
  max: 50,
  step: 1,
  defaults: '0px',
};

export const socialIconSizeDescriptor: SliderControlDescriptor = {
  property: SLIDER_CSS_PROPS.PMW_ICON_SIZE,
  labelKey: 'pmwjs_icon_size',
  unit: 'px',
  min: 0,
  max: 80,
  step: 1,
  defaults: '38px',
};
